import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { get } from "@/lib/api";
import { LoadingState, ErrorState, EmptyState } from "@/components/common/States";
import { TaskCard } from "./FieldHome";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ClipboardList } from "lucide-react";

export default function FieldTasks() {
  const [tab, setTab] = useState("open");
  const q = useQuery({ queryKey: ["field-tasks", tab], queryFn: () => get("/tasks", { mine: true, include_done: tab === "done" }) });
  const today = new Date().toISOString().slice(0, 10);
  const rows = (q.data || []).map((t) => ({ ...t, overdue: t.due_date && t.due_date < today && !["fullfort", "avbrutt"].includes(t.status) })).filter((t) => (tab === "done" ? ["fullfort", "avbrutt"].includes(t.status) : !["fullfort", "avbrutt"].includes(t.status)));
  return (
    <div className="space-y-4 fade-up" data-testid="field-tasks-page">
      <div className="flex items-center justify-between">
        <h1 className="text-[22px] font-display font-semibold tracking-tight">Mine oppgaver</h1>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="h-9"><TabsTrigger value="open" data-testid="field-tasks-tab-open">Åpne</TabsTrigger><TabsTrigger value="done" data-testid="field-tasks-tab-done">Fullførte</TabsTrigger></TabsList>
        </Tabs>
      </div>
      {q.isLoading ? <LoadingState /> : q.error ? <ErrorState error={q.error} onRetry={q.refetch} /> : rows.length === 0 ? <EmptyState icon={ClipboardList} title={tab === "done" ? "Ingen fullførte oppgaver" : "Ingen åpne oppgaver"} description={tab === "done" ? "Fullførte oppgaver vises her." : "Du har ingen tildelte oppgaver akkurat nå."} /> : (
        <div className="space-y-2">{rows.map((t) => <TaskCard key={t.id} t={t} />)}</div>
      )}
    </div>
  );
}
